import { Component, OnInit, Output, EventEmitter, ViewChild, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { UserInfo } from 'src/app/user/UserInfo';
import { UserService } from 'src/app/user/user.service';
import { Role } from 'src/app/common/role';
import { ApportisHubService } from 'src/app/apportis.hub.service';
import { Router } from '@angular/router';
import { OrgService } from 'src/app/organization/org.service';
import { PatientService } from 'src/app/patient/patient.service';
import { NotifierService } from 'angular-notifier';
import { MsgBoxComponent } from 'src/app/common/msg-box';
import { ThemeService } from 'src/app/theme/theme.service';
import { HttpClient } from '@angular/common/http';
import { Constants } from 'src/app/app.constants';
import { WaitingRoomService } from 'src/app/waiting-room/waiting-room.service';
import { TranslateOrgSpecificPipe } from 'src/app/common/pipes/translate-org-specific.pipe';
import { CovidTrackingService } from 'src/app/covid-tracking/covid-tracking.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.css'],
  providers: [PatientService]
})
export class TopMenuComponent implements OnInit, OnDestroy, AfterViewInit {

  userInfo: UserInfo = new UserInfo();
  username: string;
  role: string;
  orgName: string;
  is_client = false;
  public isOrgSwitched = false;
  public isReadyForEmergency = false;
  public showHelp = false;
  public isclinicianCheckIn = false;
  private patientId;
  private uniqueId;
  private patientLat;
  private patientLng;
  private browserType;
  private ipAddress;
  private ip;
  private secretCode;
  private clinicianId;
  private sessionId;
  profileImageUrl: any;
  orgLogoImageUrl = '../../assets/logo.png';
  public isHelpNowRequested = false;
  is_university = false;
  public secondShotDetailsavailable = false;
  secondShotdate: string;
  @Output() toggleSidebar: EventEmitter<any> = new EventEmitter<any>();
  @Output() userInfoLoaded: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('msgbox') msgbox: MsgBoxComponent;
  userOrganizationType: string;
  is_hospital_organisation = true;
  count: any;
  is_count_available = false;
  waitingRoomlevel: string;
  clinicianName: string;
  appt_date: any;
  isClinician = false;
  ClientLabel = Constants.Client;
  ClinicianLabel = Constants.Clinician;
  PatientLabel = Constants.Patient;
  is_Caa = false;
  is_CaseManagement = true;
  logoHeight: any = 50;
  logoWidth: any = 130;
  university_school = false;
  ResourceFilePath: string;
  isReconnect = false;
  dbSessionId: string;
  // timeout;
  isClinicianDisconnect = false;
  isIos = false;
  isEnableDonation = false;
  paymentUrl: any = null;
  isSocialWorker = false;
  is_criticalResponse = false;
  allUserRoles: any[] = [];
  defaultRole: string;
  constructor(private userService: UserService
    , private apportisService: ApportisHubService
    , private router: Router
    , private orgService: OrgService
    , private patientService: PatientService
    , private notifier: NotifierService
    , private themeService: ThemeService
    , private http: HttpClient
    , private apportisHubservice: ApportisHubService
    , private translateOrgSpecific: TranslateOrgSpecificPipe
    , private waitingroomService: WaitingRoomService,
    private covidtrackingservices: CovidTrackingService,
    private deviceService: DeviceDetectorService,
    private el: ElementRef) {
    this.element = el.nativeElement;
  }
  // Flyout
  title = 'Switch Role';
  isHideTitle = false;
  isHideCloseButton = false;
  width = 350;
  public isShow = false;
  public DivisShow = false;
  private element: any;

  ngOnInit() {
    // Flyout
    document.body.appendChild(this.element);
    this.element.addEventListener('click', el => {
      if (this.isShow && el.target.className != 'dropdown-item selectedRole defaultRole ng-star-inserted') {
        if (el.target.className != 'dropdown-item ng-star-inserted') {
          this.closeSwitchRole();
        }
      }
    });
    if (this.userService.isHelpFromSignin == undefined || !this.userService.isHelpFromSignin) {
      if (this.userService.getAuthToken()) {
        this.userService.getUserInfo().subscribe((info: any) => {
          if (info) {
            if (info.token != null && info.token != undefined && info.token != '') {
              this.userService.setAuthToken(info.token);
              window.location.replace('/app');
            }
            info.userAllRoles.forEach(element => {
              element.role_name = this.translateOrgSpecific.transform(element.role_name);
              if (element.isDefault) {
                this.defaultRole = element.role_name;
              }
            });
            this.allUserRoles = info.userAllRoles;
            this.allUserRoles.sort((a, b) => a.role_name.localeCompare(b.role_name));
            if (info.orgType == Constants.University || info.orgType == Constants.School) {
              this.university_school = true;
            }
            if (info.orgType == Constants.Opi_org) {
              this.is_criticalResponse = true;
            } else {
              this.is_criticalResponse = false;
            }
            this.username = info.firstName + ' ' + info.lastName;
            if (this.username.length > 35) {
              this.username = this.username.substring(0, 35);
            }
            this.ResourceFilePath = info.resourceFilePath ? info.resourceFilePath : '';
            this.role = info.roles[0];
            // get initialize the apportis connection
            if (this.role == Role.Patient || this.role == Role.SocialWorker
              || this.role == Role.Clinician || this.role == Constants.CaseManager || this.role == Constants.Participants) {
              this.apportisService.iniitializeHub();
            }
            if (this.role == Role.Participants || this.role == Role.Patient) {
              this.is_client = true;
            }
            this.orgName = info.orgName;
            if (info.isCaseManagement == undefined) {
              this.is_CaseManagement = false;
            } else {
              this.is_CaseManagement = info.isCaseManagement;
              if (info.roles[0] == Role.ClinicAdmin) {
                this.role = Role.LocationAdmin;
              }
            }
            // reading Json
            this.readingJson(this.ResourceFilePath, info);
            // CAA labels
            if (this.is_CaseManagement) {
              this.ClientLabel = Constants.Participants;
              this.PatientLabel = Constants.Participants;
              this.ClinicianLabel = Constants.CaseManager;
              this.is_Caa = true;
            }
            // Covid Tracking Info
            if (info.isCovidTracking && (this.role == Role.Patient || this.role == Role.Participants)) {
              this.covidtrackingservices.getNextCovidVaccinationDate().subscribe((data: any) => {
                if (data && data.isValidDate) {
                  this.secondShotDetailsavailable = true;
                  this.secondShotdate = data.secondShotDate;
                }
              });
            }
            this.isClinician = this.role == this.ClinicianLabel ? true : false;
            this.isSocialWorker = this.role == Role.SocialWorker ? true : false;
            this.profileImageUrl = info.profileImageUrl;
            this.userService.CurrentUser = info;
            this.isOrgSwitched = this.userService.CurrentUser.isOrgSwitched;
            this.getOrganizationDetails();
            this.themeService.orgLogoImageUrl.subscribe(logo => {
              if (logo != undefined && logo != null) {
                this.orgLogoImageUrl = logo;
              } else {
                this.orgLogoImageUrl = '../../assets/logo.png';
              }
            });
          }
        });
      }
    }
    let connected: any;
    connected = this.apportisHubservice.connected.subscribe((status) => {
      if (status && this.apportisHubservice.connection) {
        if (this.apportisHubservice.connection) {
          this.initializeHub();
          // clinician checkin
          this.apportisHubservice.connection.on('waitingRoomCheckedIn', (objAppt: any, name: any, is_updation: any) => {
            if (objAppt) {
              this.getPatientCount();
            }
          });
          // client disconnected
          this.apportisHubservice.connection.on('ClientDisconnect', (objResult: any, isAppointment: any, sessionId: any) => {
            if (objResult) {
              const currentUrl = this.router.url;
              if (!currentUrl.includes('clinicianvideo/casemanagement/show') && !currentUrl.includes('clinicianvideo/show')) {
                this.getPatientCount();
              }
            }
          });
        }
        if (connected) {
          connected.unsubscribe();
        }
      }
    });
    this.userService.imageUrl.subscribe(url => {
      if (url != '' && url != undefined) {
        this.profileImageUrl = url;
      }
    });
    this.userService.setActiveLogin().subscribe((data: any) => {
    });
  }

  ngAfterViewInit() {
    const deviceInfo = this.deviceService.getDeviceInfo();
    this.isIos = [
      'mac',
      'ios'
    ].includes(deviceInfo.os);
    if (this.isIos && (deviceInfo.browser.toLowerCase() == Constants.chrome || deviceInfo.browser.toLowerCase() == Constants.firefox)) {
      setTimeout(() => {
        this.msgbox.alert(this.translateOrgSpecific.transform('BrowserNotSupport'), 'Message', (() => {
        }));
      });
    }
  }
  ngOnDestroy(): void {
    this.element.remove();
  }
  initializeHub() {
    if (this.role == this.ClinicianLabel) {
      const isAvailable = this.userService.getSessionItem(Constants.Available);
      if (isAvailable != undefined && isAvailable != '' && isAvailable != null) {
        if (isAvailable == 'true') {
          this.isReadyForEmergency = true;
          if (this.userOrganizationType == Constants.Opi_org) {
            this.userService.enableEmergency(true).subscribe();
            this.apportisService.connection.on('helpNowRequested', (id: any, patientid: any, patientLat: any,
              patientLng: any, browserType: any, ipAddress: any, secretCode: any) => {
              if (!this.showHelp) {
                this.uniqueId = id;
                this.patientId = patientid;
                this.patientLat = patientLat;
                this.patientLng = patientLng;
                this.browserType = browserType;
                this.ipAddress = ipAddress;
                this.secretCode = secretCode;
                this.clinicianId = this.userService != undefined
                  && this.userService.CurrentUser != undefined ? this.userService.CurrentUser.userId : 0;
                this.showHelp = true;
                this.apportisService.connection.on('helpNowCancelled', () => {
                  this.showHelp = false;
                  this.apportisService.connection.off('helpNowCancelled');
                });
              }
            });
          } else {
            this.userService.teleMedicine(true).subscribe();
          }
        } else {
          this.isReadyForEmergency = false;
        }
      }
    }
  }
  onToggleSidebar() {
    this.toggleSidebar.emit();
  }

  public helpNowConfirm() {
    this.showHelp = false;
    // get county and zip
    const _this = this;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: _this.patientLat, lng: _this.patientLng } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results && results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
        _this.patientService.handleEmergency(_this.uniqueId).subscribe((info: any) => {
          if (info.status) {
            const session = {
              appointmentId: 0,
              patientId: _this.patientId,
              clinicianId: _this.clinicianId,
              anonymousUserId: 0,
              latitude: _this.patientLat,
              longitude: _this.patientLng,
              ipAddress: _this.ipAddress,
              browserType: _this.browserType,
              secretCode: _this.secretCode,
              uniqueId: _this.uniqueId
            };
            // call the method for insert session
            _this.patientService.insertSession(session, true).subscribe((res: any) => {
              _this.userService.getUserLicenceNumberandName().subscribe((data) => {
                if (data) {
                  const name = data.firstName + ' ' + data.lastName;
                  if (_this.is_CaseManagement) {
                    _this.router.navigate(['/clinicianvideo/casemanagement/show', info.sessionId, _this.uniqueId, res.sessionId,
                      res.secretCode, _this.patientId, zipcode, county, name]);
                  } else {
                    _this.router.navigate(['/clinicianvideo/show', info.sessionId,
                      _this.uniqueId, res.sessionId, res.secretCode, _this.patientId, zipcode, county, name]);
                  }
                }
              });
            });
          } else {
            _this.msgbox.alert(this.translateOrgSpecific.transform('RequestAlreadyAttendedByAnotherClincian'));
          }
        });
      } else {
        _this.patientService.handleEmergency(_this.uniqueId).subscribe((info: any) => {

          if (info.status) {
            const session = {
              appointmentId: 0,
              patientId: _this.patientId,
              clinicianId: 0,
              anonymousUserId: 0,
              latitude: _this.patientLat,
              longitude: _this.patientLng,
              ipAddress: _this.ipAddress,
              browserType: _this.browserType,
              secretCode: _this.secretCode,
              uniqueId: _this.uniqueId,
            };
            // call the method for insert session
            _this.patientService.insertSession(session).subscribe((res: any) => {

              _this.userService.getUserLicenceNumberandName().subscribe((data) => {
                if (data) {
                  const name = data.firstName + ' ' + data.lastName;
                  _this.router.navigate(['/clinicianvideo/show', info.sessionId, _this.uniqueId, res.sessionId, res.secretCode, _this.patientId, zipcode, county, name]);
                }
              });
            });

          } else {
            _this.msgbox.alert(this.translateOrgSpecific.transform('RequestAlreadyAttendedByAnotherClincian'));
          }
        });
      }
    });
  }

  ClinicainReconnectConfirm() {
    const _this = this;
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: _this.patientLat, lng: _this.patientLng } }, function (results, status) {
      let zipcode = '';
      let county = '';
      if (results[1]) {
        for (let i = 0; i < results.length; i++) {
          if (results[i].types[0] === 'postal_code') {
            zipcode = results[i].address_components[0].long_name;
          }
          if (results[i].types[0] === 'administrative_area_level_2') {
            county = results[i].address_components[0].long_name;
          }
        }
        _this.patientService.patientConnected(zipcode, county, _this.sessionId, _this.clinicianId).subscribe((info: any) => {
          _this.userService.getUsername(_this.patientId).subscribe((data) => {
            if (data) {
              const name = data.name;
              _this.router.navigate(['/clientvideo/show', _this.sessionId, name]);
            }
          });
        });
      } else {
        _this.patientService.patientConnected(zipcode, county, _this.sessionId, _this.clinicianId).subscribe((info: any) => {
          _this.userService.getUsername(_this.patientId).subscribe((data) => {
            if (data) {
              const name = data.name;
              _this.router.navigate(['/clientvideo/show', _this.sessionId, name]);
            }
          });
        });
      }
    });
  }

  public emergencyChanged() {

    if (this.apportisService.isConnected) {
      // set into session storage
      this.userService.setSessionItem(this.isReadyForEmergency.toString(), Constants.Available);
      if (this.userOrganizationType == Constants.Opi_org) { // check organisation type  like hospital or opi

        if (this.isReadyForEmergency) {  // EnableEmergency toggle enable or not
          this.userService.enableEmergency(true).subscribe();

          this.apportisService.connection.on('helpNowRequested', (id: any, patientid: any, patientLat: any, patientLng: any, browserType: any, ipAddress: any, secretCode: any) => {
            if (!this.showHelp) {
              this.uniqueId = id;
              this.patientId = patientid;
              this.patientLat = patientLat;
              this.patientLng = patientLng;
              this.browserType = browserType;
              this.ipAddress = ipAddress;
              this.secretCode = secretCode;
              this.showHelp = true;
              this.apportisService.connection.on('helpNowCancelled', () => {
                this.showHelp = false;
                this.apportisService.connection.off('helpNowCancelled');
              });
            }
          });
        } else {
          this.apportisService.connection.off('helpNowRequested');
          this.userService.enableEmergency(false).subscribe();
        }

      } else if (this.userOrganizationType == Constants.Hospital_org || this.userOrganizationType == Constants.University || this.userOrganizationType == Constants.School) { // check organisation type  like hospital or opi

        // check  telemedicine enable or not
        if (this.isReadyForEmergency) {
          this.userService.teleMedicine(true).subscribe();
        } else {
          this.userService.teleMedicine(false).subscribe();
        }
      }
    } else {
      this.msgbox.alert(this.translateOrgSpecific.transform('ConnectionNotEstablishedMsg'), '');
      setTimeout(() => {
        this.isReadyForEmergency = false;
      });
    }
  }

  helpNow() {
    if (this.apportisService.isConnected) {
      this.isHelpNowRequested = true;
      navigator.geolocation.getCurrentPosition(this.sendHelpNow.bind(this), () => {
        this.sendHelpNow(null);
      }, { timeout: 3000 });
    } else {
      this.msgbox.alert(this.translateOrgSpecific.transform('ConnectionNotEstablishedMsg'), '');
    }
  }



  getposition(position) {
    this.isclinicianCheckIn = true;
    const info: any = {};
    if (position) {
      this.patientLat = position.coords.latitude;
      this.patientLng = position.coords.longitude;
    } else {
      this.patientLat = 0;
      this.patientLng = 0;
    }
  }

  private sendHelpNow(position) {
    this.apportisService.connection.on('ClinicianAvailable', (data: any) => {
      this.apportisService.connection.off('ClinicianAvailable');
      this.isHelpNowRequested = false;
      if (data.status) {
        this.userService.getUsername(this.patientId).subscribe((datas) => {
          if (datas) {
            const name = datas.name;
            this.router.navigate(['/clientvideo/show', data.sessionId, name]);
          }
        });
      } else {
        this.msgbox.alert(this.translateOrgSpecific.transform('NoClinicianAvailable'), '');
      }
    });

    const info: any = {};
    if (position) {
      info.latitude = position.coords.latitude;
      info.longitude = position.coords.longitude;
    }
    // getting browser type and ipaddress
    info.browserType = this.getBrowserType();
    info.ip = this.userService.getIpaddress();
    info.secretCode = '';
    this.patientService.helpNow(info).subscribe(status => {
      if (!status) {
        this.isHelpNowRequested = false;
        this.apportisService.connection.off('ClinicianAvailable');
        this.msgbox.alert(this.translateOrgSpecific.transform('ErrorOccured'), '');
      }
    }, (err => {
      this.isHelpNowRequested = false;
      this.apportisService.connection.off('ClinicianAvailable');
      this.msgbox.alert(this.translateOrgSpecific.transform('ErrorOccured'), '');
    }));
  }

  checkLogIn() {
    if (localStorage.getItem('username') != null) {
      this.username = localStorage.getItem('username');
      return true;
    }
    return false;
  }

  signOut() {
    this.userService.deleteActiveLogin(this.userService.CurrentUser.userId);
    this.apportisService.closeConenction();
    this.userService.CurrentUser = null;
    localStorage.clear();
  }
  switchToSysAdmin() {
    this.userService.switchToSysAdmin().subscribe(
      (data: any) => {
        this.userService.setAuthToken(data['token']);
        window.location.replace('/app');
      },
      (err: any) => {

        this.notifier.notify('error', this.translateOrgSpecific.transform('FailedToExitOrganization'));
      }
    );
    return false;
  }

  getOrganizationDetails() {
    this.orgService.getCurrentOrganizationDetails().subscribe(
      (data: any) => {
        this.waitingRoomlevel = data.waitingRoomlevel;
        this.userOrganizationType = data.organizationType;
        if (data.isEnableDonation) {
          this.isEnableDonation = data.isEnableDonation;
          this.paymentUrl = data.paymentUrl;
        }
        if (this.userOrganizationType == Constants.Hospital_org) {
          this.is_hospital_organisation = true;
          this.is_university = false;
        } else if (this.userOrganizationType == Constants.University || this.userOrganizationType == Constants.School) {
          this.is_hospital_organisation = false;
          this.is_university = true;
        } else {
          this.is_hospital_organisation = false;
        }
        if (data.orgLogoUrl != null && data.orgLogoUrl != undefined && data.orgLogoUrl != '') {
          this.themeService.orgLogoImageUrl.next(data.orgLogoUrl);
          this.orgLogoImageUrl = this.themeService.orgLogoImageUrl.value;
          if (data.appLogoHeight) {
            this.logoHeight = data.appLogoHeight;
          }
          if (data.appLogoWidth) {
            this.logoWidth = data.appLogoWidth;
          }
        } else {
          this.themeService.orgLogoImageUrl.next('../../assets/logo.png');
          this.orgLogoImageUrl = this.themeService.orgLogoImageUrl.value;
        }
        if (this.role == Role.Patient || this.role == Role.Clinician
          || this.role == Constants.CaseManager || this.role == Constants.Participants || this.role == Role.SocialWorker) {
          this.getPatientCount();
        }
      });
  }


  public getBrowserType() {
    const agent = window.navigator.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('edge') > -1:
        return 'edge';
      case agent.indexOf('opr') > -1 && !!(<any>window).opr:
        return 'opera';
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
        return 'chrome';
      case agent.indexOf('trident') > -1:
        return 'ie';
      case agent.indexOf('firefox') > -1:
        return 'firefox';
      case agent.indexOf('safari') > -1:
        return 'safari';
      default:
        return 'other';
    }
  }
  // get waiting room queue size
  getPatientCount() {

    this.waitingroomService.getPatientCount(this.waitingRoomlevel).subscribe((count: any) => {
      if (count) {
        if (count > 0 && this.userOrganizationType != Constants.Opi_org) {
          this.count = count;
          this.is_count_available = true;
        } else {
          this.count = count;
          this.is_count_available = false;
        }
      } else {
        this.count = count;
        this.is_count_available = false;
      }
    });

  }

  readingJson(resourceFilePath, info) {
    // reading jason
    const promise = new Promise<void>((resolve, reject) => {
      let json = Constants.Apportis;
      if (resourceFilePath != null && resourceFilePath != undefined && resourceFilePath != '') {
        json = resourceFilePath;
      }

      this.http.get('assets/org-translate/' + json + '.json').toPromise().then(data => {
        this.userService.setSessionItem(JSON.stringify(data), Constants.OrgSpecificResource);
        this.userInfoLoaded.emit(info);
      });
    });
    return promise;
  }

  onDonate() {
    window.open(this.paymentUrl);
  }
  switchRole(event) {
    this.allUserRoles.forEach(element => {
      if (event.role_name == element.role_name) {
        element.isActive = true;
      } else {
        element.isActive = false;
      }
    });

    this.userService.switchToOtherRole(event.application_role_id).subscribe(
      (data: any) => {
        this.userService.setAuthToken(data['token']);
        if (data['theme'] != null && data['theme'] != '') {
          // set current theme
          this.themeService.currentTheme.next(data['theme']);
        } else {
          // set current theme
          this.themeService.currentTheme.next(Constants.Default);
        }
        window.location.replace('/app');
      }
    );

  }
  // Flyout
  openSwitchRole(): void {
    this.element.style.display = 'block';
    this.isShow = true;
    this.DivisShow = true;
    document.body.classList.add('flyout-open');
  }
  closeSwitchRole() {
    this.isShow = false;
    setTimeout(() => {
      document.body.classList.remove('flyout-open');
      this.DivisShow = false;
    }, 500);

  }
  onClickProfileMenu() {
    if (this.isShow) {
      this.closeSwitchRole();
    }
  }
}
